import e from "../managers/braze-instance.js";
import jt from "./utils/push-utils.js";
export function isPushBlocked() {
  if (e.rr()) return jt.isPushBlocked();
}
